import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';

export type CataloguePageListContentItemCardSkeletonProps =
  StandardDivProps<CataloguePageListContentItemCardSkeletonClassKey>;

export type CataloguePageListContentItemCardSkeletonClassKey = 'root';

const themeSettings = { name: 'CataloguePageListContentItemCardSkeleton' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      minWidth: 286,
      maxWidth: '100%',
      flexBasis: '100%',
      flexGrow: 0,
      flexShrink: 1,
      padding: theme.spacing(1),
      margin: theme.spacing(1),
      border: '1px solid',
      borderColor: theme.palette.divider,
      borderRadius: theme.spacing(0.5),
      '@media(min-width: 650px)': {
        maxWidth: 'calc(50% - 16px)',
        flexBasis: 'calc(50% - 16px)',
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: 'calc(100% - 16px)',
        padding: theme.spacing(2),
      },
      '@media(min-width: 1700px)': {
        minWidth: 324,
        maxWidth: 'calc(33.3% - 16px)',
        flexBasis: 0,
        flexGrow: 1,
        flexShrink: 1,
      },
      '@media(min-width: 1990px)': {
        maxWidth: 'calc(25% - 16px)',
      },
      '@media(min-width: 2330px)': {
        maxWidth: 'calc(20% - 16px)',
        minWidth: 'calc(20% - 16px)',
      },
    },
  }),
  themeSettings,
);

const CataloguePageListContentItemCardSkeleton = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardSkeletonProps
>(({ className, classes: pClasses }, ref) => {
  const classes = useStyles({ classes: pClasses });

  return (
    <div ref={ref} className={clsx(classes.root, className)}>
      <Skeleton variant='rect' width={120} height={20} animation='pulse' />
      <Box alignSelf='center'>
        <Skeleton variant='rect' width={265} height={192} animation='wave' />
      </Box>
      <Skeleton variant='text' height={32} />
      <Skeleton variant='text' height={64} />
      <Box display='flex' justifyContent='flex-end'>
        <Skeleton variant='text' width={120} height={45} />
      </Box>
      <Box display='flex' justifyContent='space-between'>
        <Skeleton variant='text' width={120} height={64} />
        <Skeleton variant='text' width={120} height={64} />
      </Box>
    </div>
  );
});

CataloguePageListContentItemCardSkeleton.displayName = 'CataloguePageListContentItemCardSkeleton';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardSkeleton);
